import React, { memo } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

export const MESSAGE_TARGET_ID = 'jira-board-inline-editing-summary-target';

const styles = cssMap({
	root: {
		zIndex: 1,
		flexGrow: 1,
		marginRight: token('space.400'),
	},
});

export const NudgeWrapper = memo(
	({
		shouldShowChangeboarding,
		isChangeBoardingTargetCard,
		children,
	}: {
		children: React.ReactNode;
		shouldShowChangeboarding: boolean;
		isChangeBoardingTargetCard: boolean;
	}) => {
		if (isChangeBoardingTargetCard) {
			const targetId = shouldShowChangeboarding ? MESSAGE_TARGET_ID : undefined;
			return (
				<Box id={targetId} testId={targetId} xcss={styles.root}>
					{children}
				</Box>
			);
		}
		return children;
	},
);
